import React, { useEffect } from "react";
import '../../CSS/Empleados.css'
import { FaArrowLeftLong, FaHelmetSafety } from "react-icons/fa6";
import { GiOfficeChair } from "react-icons/gi";
import { useNavigate } from "react-router";
import { getPermission } from "../../Conexiones/Conexion";

function IndexEmpleados() {
    const navigate = useNavigate()
    useEffect(()=>{
        const getEmpleados = async () =>{
            const usuario = JSON.parse(sessionStorage.getItem('user'));
            const idUsuario = usuario[0].idUsuario;
            const permiso = await getPermission(idUsuario,10);
            if(!permiso){
                navigate('/inicio');
            }
        }
        getEmpleados()
    },[navigate])
    
    const selectedArea = (n) => {
        if(n===1){
            navigate('/inicio/Catalogos/Empleados/Campo');
        }
        if(n===2){
            navigate('/inicio/Catalogos/Empleados/Oficina');
        }
        
    }
    const regresar = () => {
        navigate('/inicio/Catalogos');
    }
    return (
        <div className='empleados'style={{paddingInline:50}}>
            <div className='contabilidades-header'>
                <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                <label className="text-uppercase">GESTIÓN DE EMPLEADOS</label>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-4">
                <div className="col-sm-6 mb-3 mb-sm-0 " key={1} onClick={()=>selectedArea(1)}>
                    <div className='card h-80 btncolor btn' style={{ marginTop: '5px', textAlign: "center", padding:'5px', fontSize:'20px'}} >
                        <div style={{width:'100%',  padding:10,}}>
                            <div style={{display:"flex",borderRadius:10, padding:10}}>
                                <div style={{width:'20%',display:"flex",justifyContent:"center",alignItems:"center",padding:10}}>
                                    <div style={{justifySelf:"center"}}><FaHelmetSafety fontSize={50} /></div>
                                </div>
                                <div style={{width:'80%',display:"flex",justifyContent:"center",alignItems:"center",padding:10}}>
                                    <div style={{justifySelf:"center", fontSize:30, textAlign:"left", width:'100%',}}>
                                        CAMPO
                                    </div>
                                </div>
                            </div>
                        </div>          
                    </div>
                </div>
                <div className="col-sm-6 mb-3 mb-sm-0 " key={2} onClick={()=>selectedArea(2)}>
                    <div className='card h-80 btncolor btn' style={{ marginTop: '5px', textAlign: "center", padding:'5px', fontSize:'20px'}} >
                        <div style={{width:'100%',  padding:10,}}>
                            <div style={{display:"flex",borderRadius:10, padding:10}}>
                                <div style={{width:'20%',display:"flex",justifyContent:"center",alignItems:"center",padding:10}}>
                                    <div style={{justifySelf:"center"}}><GiOfficeChair fontSize={50} /></div>
                                </div>
                                <div style={{width:'80%',display:"flex",justifyContent:"center",alignItems:"center",padding:10}}>
                                    <div style={{justifySelf:"center", fontSize:30, textAlign:"left", width:'100%',}}>
                                        OFICINA
                                    </div>
                                </div>
                            </div>
                        </div>           
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IndexEmpleados